/**
 * chat-header-layout.ts — Đầu khung chat gọn lại theo BỀ RỘNG THẬT CỦA KHUNG CHAT (không theo bề rộng cửa sổ).
 *
 * Khung chat là cột giữa của màn Hộp thư (cạnh danh sách hội thoại và cột hồ sơ khách) nên trên máy tính nhỏ / máy tính bảng nó chỉ còn
 * ~450–650px dù cửa sổ rộng ~1280px — media query theo cửa sổ không bắt được. Lỗi gốc: nhóm có tên dài + "Thành viên (15)" + nhãn +
 * thanh phân công ("Chưa phân công", Nhận, Giao ≈ 330px) + chế độ AI + các nút ⇒ cụm nút bên phải (shrink-0) chiếm hết chỗ, khối tên
 * co về 0 nhưng chữ vẫn vẽ tràn và đè lên nhau.
 *
 *  - gọn (`compact`):  thanh phân công xuống HÀNG RIÊNG dưới đầu khung (như điện thoại); nút chế độ AI chỉ còn biểu tượng;
 *                      "Thư viện" vào menu ⋮ → đầu khung chỉ còn tên + vài nút biểu tượng.
 *  - hẹp (`tight`):    thêm: bỏ ảnh đại diện để nhường chỗ cho tên.
 * Điện thoại (`mobile`) luôn là cả hai.
 */
export const COMPACT_BELOW = 900
export const TIGHT_BELOW = 560

export interface ChatHeaderLayout { compact: boolean; tight: boolean }

/** `width` = bề rộng khung chat (px); 0 / chưa đo → bố cục đầy đủ (không nháy sang gọn rồi quay lại). */
export function chatHeaderLayout(width: number, mobile: boolean): ChatHeaderLayout {
  if (mobile) return { compact: true, tight: true }
  const measured = Number.isFinite(width) && width > 0
  return { compact: measured && width < COMPACT_BELOW, tight: measured && width < TIGHT_BELOW }
}
